import React, { useRef } from 'react';
import { Avatar as DefaultAvatar } from '../Avatar';
import { truncate } from '../../utils';
var UnMemoizedChannelPreviewLastMessage = function (props) {
    var active = props.active, _a = props.Avatar, Avatar = _a === void 0 ? DefaultAvatar : _a, channel = props.channel, displayImage = props.displayImage, displayTitle = props.displayTitle, latestMessage = props.latestMessage, _b = props.latestMessageLength, latestMessageLength = _b === void 0 ? 20 : _b, setActiveChannel = props.setActiveChannel, unread = props.unread, watchers = props.watchers;
    var channelPreviewButton = useRef(null);
    var onSelectChannel = function () {
        if (setActiveChannel) {
            setActiveChannel(channel, watchers);
        }
        if (channelPreviewButton === null || channelPreviewButton === void 0 ? void 0 : channelPreviewButton.current) {
            channelPreviewButton.current.blur();
        }
    };
    var unreadClass = unread && unread >= 1 ? 'str-chat__channel-preview--unread' : '';
    var activeClass = active ? 'str-chat__channel-preview--active' : '';
    return (React.createElement("div", { className: "str-chat__channel-preview " + unreadClass + " " + activeClass },
        React.createElement("button", { "data-testid": 'channel-preview-button', onClick: onSelectChannel, ref: channelPreviewButton },
            unread && unread >= 1 ? React.createElement("div", { className: 'str-chat__channel-preview--dot' }) : null,
            React.createElement(Avatar, { image: displayImage, name: displayTitle }),
            React.createElement("div", { className: 'str-chat__channel-preview-info' },
                React.createElement("span", { className: 'str-chat__channel-preview-title' }, displayTitle),
                React.createElement("span", { className: 'str-chat__channel-preview-last-message' }, truncate(latestMessage, latestMessageLength)),
                unread && unread >= 1 ? (React.createElement("span", { className: 'str-chat__channel-preview-unread-count' }, unread)) : null))));
};
/**
 * @deprecated - This UI component will be removed in the next major release.
 *
 * Used as preview component for channel item in [ChannelList](#channellist) component
 */
export var ChannelPreviewLastMessage = React.memo(UnMemoizedChannelPreviewLastMessage);
